import { Box, Button, Chip, Stack, Switch, Typography } from '@mui/material';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import ToolTip from '../../ToolTip/ToolTip';
import { rejectionReasons } from '../../../utils/constants/rejectionReasonJson';
import { DeleteButtonNew } from '../../mui/Buttons/Buttons';

export const REFUND_REQUEST_TABLE_HEAD = [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    sortable: true,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 100,
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 200,
    sortable: true,
  },
  {
    field: 'admission_date',
    headerName: 'Admission Date',
    width: 200,
  },
  {
    field: 'course_name',
    headerName: 'Course Name',
    width: 200,
    sortable: true,
  },
  {
    field: 'total_sessions',
    headerName: 'Total Sessions',
    width: 150,
  },
  {
    field: 'completed_sessions',
    headerName: 'Completed Sessions',
    width: 150,
  },
  {
    field: 'oga_name',
    headerName: 'OGA Name',
    width: 200,
  },
  {
    field: 'cro_name',
    headerName: 'CRO Name',
    width: 200,
  },
  {
    field: 'reason_category',
    headerName: 'Reason Category',
    width: 150,
  },
  {
    field: 'requested_on',
    headerName: 'Requested On',
    width: 200,
  },
  {
    field: 'total_fee',
    headerName: 'Total Fee',
    width: 150,
  },
  {
    field: 'pm_status',
    headerName: 'PM Status',
    width: 150,
    renderCell: (params) => {
      if (params.row.pm_status === 1) {
        return <Chip label="Approved" color="success" variant="outlined" />;
      } else if (params.row.pm_status === 2) {
        return <Chip label="On Hold" color="warning" variant="outlined" />;
      } else if (params.row.pm_status === 0) {
        return <Chip label="Rejected" color="error" variant="outlined" />;
      } else {
        return null;
      }
    },
  },
  {
    field: 'pm_remarks',
    headerName: 'PM Remarks',
    width: 200,
    renderCell: (params) => {
      if (params.row.pm_remarks === null) {
        return 'N/A';
      } else {
        return <ToolTip content={params.row.pm_remarks} expand={params.row.pm_remarks} />;
      }
    },
  },
  {
    field: 'finance_status',
    headerName: 'Finance Status',
    width: 150,
    renderCell: (params) => {
      if (params.row.finance_status === 1) {
        return <Chip label="Approved" color="success" variant="outlined" />;
      } else if (params.row.finance_status === 2) {
        return <Chip label="On Hold" color="warning" variant="outlined" />;
      } else if (params.row.finance_status === 0) {
        return <Chip label="Rejected" color="error" variant="outlined" />;
      } else {
        return null;
      }
    },
  },
  {
    field: 'finance_remarks',
    headerName: 'Finance Remarks',
    width: 200,
    renderCell: (params) => {
      if (params.row.finance_remarks === null) {
        return 'N/A';
      } else {
        return <ToolTip content={params.row.finance_remarks} expand={params.row.finance_remarks} />;
      }
    },
  },
  {
    field: 'current_status',
    headerName: 'Current Status',
    width: 200,
  },
];

export const TableHead_Refund_fn = ({
  setOpenTutorsTable,
  setOpenRejectionReason,
  selectedType,
  setOpenDetails,
  setChatOpen,
  setSelectedRow,
  setApprovalModal,
  setEditReason,
  setOpenBankDetails,
  Delete,
  approvalOrVerify = false,
  setDeleteDialogue,
  isFinance = false,
  onReRequestToggle,
}) => {
  const deleteButtonDisableFunction = (row) => {
    if (
      row?.cro_verification ||
      row?.expense_crm_approval ||
      row?.expense_accountant_approval ||
      row?.sogo_verification ||
      row?.holdamount_refund_fianance_status
    ) {
      return true;
    } else {
      return false;
    }
  };
  return [
    { field: 'sl_no', headerName: 'SL.No', width: 120 },
    ...(selectedType ? [] : [{ field: 'expense_id', headerName: 'Refund ID', width: 150, sortable: true }]),
    { field: 'student_name', headerName: 'Student Name', width: 250, sortable: true },
    ...(isFinance ? [{ field: 'project_name', headerName: 'Project Name', width: 200, sortable: true }] : []),
    ...(selectedType
      ? []
      : [
          {
            field: 'course_name',
            headerName: 'Course Name',
            width: 250,
            sortable: true,
            renderCell: ({ value }) => (value ? <ToolTip content={value} expand={value} /> : 'N/A'),
          },
          {
            field: 'enrolled_subject_name',
            headerName: 'Subject Name',
            width: 200,
            renderCell: ({ value }) => (value ? <ToolTip content={value} expand={value} /> : 'N/A'),
          },
        ]),
    {
      field: selectedType ? 'lead_id' : 'admn_no',
      headerName: selectedType ? 'Lead ID' : 'ADM No',
      width: 130,
      sortable: true,
    },
    {
      field: selectedType ? 'created_by' : 'raisedByName',
      headerName: 'Request Raised By',
      width: 200,
      sortable: true,
    },

    {
      field: selectedType ? 'holdamount_refund_created_on' : 'expense_timestamp',
      headerName: 'Requested On',
      width: 180,
      sortable: true,
    },
    {
      field: selectedType ? 'holdamount_refund_scheduled_date' : 'scheduled_date',
      headerName: 'Scheduled Date',
      width: 190,
      valueGetter: (params) => {
        const value = selectedType ? params.row.holdamount_refund_scheduled_date : params.row.scheduled_date;
        return value || 'Not Rescheduled yet';
      },
    },
    {
      field: 'refund_reason',
      headerName: 'Refund Reason',
      width: 300,
      renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
    },
    {
      field: selectedType ? 'holdamount_refund_amount' : 'expense_amount',
      headerName: 'Refund Amount',
      width: 200,
      sortable: true,
    },

    ...(selectedType != 1
      ? [
          {
            field: 'expense_remarks',
            headerName: 'Refund Remarks',
            width: 300,
            renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
          },
          // {
          //   field: 'sessions',
          //   headerName: 'Sessions',
          //   width: 120,
          //   valueGetter: (params) => {
          //     return params.row?.subject_enrollment_id ? params.row?.sub_sessions_held : params.row?.sessions_held;
          //   },
          // },
          {
            field: 'parent_reason',
            headerName: 'Parent Reason',
            width: 280,
            renderCell: (params) => (
              <Box display="flex" gap={1} alignItems="center">
                {params.value || 'Nil'}

                {params.value === 'Tutor Related' && (
                  <Chip
                    sx={{
                      bgcolor: '#BFDDF9',
                      color: '#05516A',
                      cursor: 'pointer',
                    }}
                    icon={<RemoveRedEyeOutlinedIcon color="inherit" sx={{ width: 20, height: 20 }} />}
                    label="View Tutor Details"
                    onClick={() =>
                      setOpenTutorsTable({
                        course_enrollment_id: params?.row?.expense_course_enrollment_id,
                        subject_enrollment_id: params?.row?.subject_enrollment_id,
                      })
                    }
                  />
                )}
              </Box>
            ),
          },
          {
            field: 'parent_requested_date',
            headerName: 'Parent Requested Date',
            width: 220,
            valueGetter: ({ value }) => (value ? value.split(' ')[0] : 'Nill'),
          },
        ]
      : []),
      {
      field: 'scheduled_date',
      headerName: 'Scheduled Date',
      width: 200,
      },
      {
        field: 'expense_transaction_date',
        headerName: 'Transaction Date',
        width: 200,
      },
      {
        field: 'accountant_remarks',
        headerName: 'Accountant Remarks',
        width:'200',
        renderCell: ({ value }) => <ToolTip content={value} expand={value} />,
      },
    {
      field: 'actions',
      headerName: 'Details / Actions',
      align: 'center',
      headerAlign: 'center',
      width: 300,
      renderCell: (params) => (
        <Box display={'flex'} gap={1}>
          <Chip
            sx={{
              bgcolor: '#BFDDF9',
              color: '#05516A',
              px: 0.5,
              cursor: 'pointer',
            }}
            icon={<RemoveRedEyeOutlinedIcon color={'inherit'} sx={{ width: 20, height: 20 }} />}
            label={approvalOrVerify ? 'View & Take Action' : 'View'}
            onClick={() => {
              if (selectedType == 1) {
                setOpenDetails(params?.row);
              } else {
                setSelectedRow(params?.row);
                setApprovalModal(true);
              }
            }}
          />
          {isFinance && (
            <Chip
              icon={<ChatBubbleOutlineOutlinedIcon sx={{ width: 17, height: 17 }} />}
              color="success"
              sx={{
                color: 'white',
                px: 0.5,
                cursor: 'pointer',
              }}
              label="Chat"
              onClick={() => {
                setSelectedRow(params.row);
                setChatOpen(true);
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: 'refundTrack',
      headerName: 'Refund Track',
      headerAlign: 'center',
      align: 'center',
      width: 150,
      renderCell: (params) => (
        <Chip
          sx={{
            bgcolor: '#BFDDF9',
            color: '#05516A',
            px: 0.5,
            cursor: 'pointer',
          }}
          icon={<RemoveRedEyeOutlinedIcon color={'inherit'} sx={{ width: 20, height: 20 }} />}
          label={'View'}
          onClick={() =>
            window.open(
              `/my-workspace/refundTrack?refundId=${
                selectedType ? params.row?.holdamount_refund_id : params.row?.expense_id
              }`,
              '_blank',
            )
          }
        />
      ),
    },

    //edit bank details
    {
      field: 'editBankDetails',
      headerName: 'Edit Bank Details',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => (
        <Chip
          label="Edit"
          color="primary"
          sx={{
            cursor: 'pointer',
            color: '#fff',
          }}
          onClick={() => {
            setSelectedRow(row);
            setOpenBankDetails(true);
          }}
        />
      ),
    },
    {
      field: selectedType ? 'holdamount_refund_fianance_status' : 'display_status',
      headerName: 'Status',
      width: 350,
      renderCell: ({ value }) => {
        const flag = Boolean(value);

        const status = { value, color: 'default' };
        if (selectedType) {
          if (value == 1) {
            status.color = 'success';
            status.value = 'Approved';
          } else if (value == 2) {
            status.color = 'error';
            status.value = 'Rejected';
          } else if (value == 3) {
            status.color = 'info';
            status.value = 'Hold';
          } else {
            status.color = 'warning';
            status.value = 'Pending';
          }
        }
        return (
          <Chip
            label={status.value}
            color={status.color}
            // color={(value) ? (value === 1 ? 'success' : 'error') : 'warning'}
            variant="outlined"
          />
        );
      },
    },
    ...(isFinance && selectedType == 0 && onReRequestToggle
      ? [
          {
            field: 'allow_re_request',
            headerName: 'Allow Re-request',
            width: 160,
            align: 'center',
            headerAlign: 'center',
            renderCell: ({ row }) => (
              <Switch
                size="small"
                color="secondary"
                checked={row?.allow_re_request == 1}
                onChange={(e) => onReRequestToggle(row, e.target.checked)}
              />
            ),
          },
        ]
      : []),
    ...(isFinance && selectedType == 0
      ? [
          {
            field: 'expense_modification_status',
            headerName: 'Rejected Updation Status',
            width: 230,
            valueGetter: ({ value }) => (value == 1 ? 'Updated' : value == 0 ? 'Update Pending' : 'N/A'),
          },
        ]
      : []),
    {
      field: selectedType ? 'hold_amount_refund_finance_rejected_reason_id' : 'accountant_rejected_reason_id',
      headerName: 'Finance Rejection / Re-Edit',
      width: 300,
      nullable: true,
      renderCell: ({ row, value }) => {
        // If no rejection reason → Not Required
        if (!value) {
          return 'N/A';
        }

        return (
          <Stack direction="row" gap={1} alignItems="center">
            {rejectionReasons.find((data) => data.id == value)?.name || ' Invalid Reason'}
            <Chip
              label="Edit"
              sx={{
                bgcolor: '#1A73E8',
                color: 'white',
                cursor: 'pointer',
                ':hover': { bgcolor: '#5798ecff' },
              }}
              disabled={approvalOrVerify || value == -1}
              onClick={() => {
                setOpenRejectionReason(true);
                setEditReason(value);
                setSelectedRow(row);
              }}
            />
          </Stack>
        );
      },
    },
    {
      field: 'rejected_amount_history',
      headerName: 'Rejected Amount History',
      width: 280,
      renderCell: ({ value }) => {
        if (!Array.isArray(value) || value.length === 0) {
          return 'N/A';
        }

        return (
          <Stack direction="column" gap={0.5} sx={{ py: 0.5 }}>
            {value.map((item) => (
              <Typography key={item.incorrect_amount_rejection_id} variant="body2">
                {Number(item.rejected_amount).toLocaleString('en-IN')} : {item.rejected_at?.split(' ')[0]}
              </Typography>
            ))}
          </Stack>
        );
      },
    },
    ...(Delete
      ? [
          {
            field: 'delete',
            headerName: 'Delete',
            width: 200,
            renderCell: ({ row }) => (
              <DeleteButtonNew
                disabled={deleteButtonDisableFunction(row)}
                onClick={() =>
                  setDeleteDialogue(
                    selectedType
                      ? { holdamount_refund_id: row?.holdamount_refund_id }
                      : { expense_id: row?.expense_id },
                  )
                }
              />
            ),
          },
        ]
      : []),
    // { field: selectedType ? 'holdamount_refund_finance_remarks' : 'expense_remarks', headerName: 'Remarks', width: 200 },
  ];
};
